exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#stackedBar {\n  margin-top: 20px; }\n\n.axis-x_stackedBar > path,\n.axis-y_stackedBar > path {\n  stroke: #4e4d4d; }\n\n.stacked_bar_line {\n  stroke: #565656;\n  stroke-width: 1.5px;\n  fill: none;\n  stroke-dasharray: 2; }\n\n.s_axis .tick line {\n  stroke: none !important; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/d3Components/StackedBarChart/style.scss
// module id = 1566
// module chunks = 0